var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import axios from "axios";
import { GithubProfileCard } from "./github_card_profile.js";
import { GithubRepoCard } from "./github_card_repo.js";
export var GithubCard = function (_a) {
    var name = _a.name, repository = _a.repository, type = _a.type, width = _a.width, height = _a.height;
    var _b = useState(null), profile = _b[0], setProfile = _b[1];
    var _c = useState(null), repo = _c[0], setRepository = _c[1];
    var _d = useState("".concat(width, "px") || "300px"), w = _d[0], setWidth = _d[1];
    var _e = useState("".concat(height, "px") || "350px"), h = _e[0], setHeight = _e[1];
    useEffect(function () {
        var url;
        if (type === "user" || type === "profile") {
            url = "https://api.github.com/users/".concat(name || "basskibo");
        }
        else {
            // if (!name || !repository) {
            //     url = `https://api.github.com/repos/basskibo/github-user-repo-card`;
            // }
            url = "https://api.github.com/repos/".concat(name || "basskibo", "/").concat(repository || "github-user-repo-card");
        }
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var dataFetched, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        dataFetched = void 0;
                        return [4 /*yield*/, axios.get(url
                            // , {
                            // 	headers: {
                            // 		Authorization: "token 6888b5336f1fbc75edb8de9961846462e0e1c218",
                            // 	},
                            // }
                            )];
                    case 1:
                        response = _a.sent();
                        // localStorage.setItem("profile", JSON.stringify(response.data));
                        dataFetched = response.data;
                        // } else {
                        // profileFetched = JSON.parse(profileInLocaleStorage);
                        // }
                        if (type === "user" || type === "profile") {
                            setProfile(dataFetched);
                        }
                        else {
                            setRepository(dataFetched);
                        }
                        console.log(dataFetched);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log("error", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    return (React.createElement("div", { style: {
            width: w, height: h, backgroundColor: "#22272E", color: "#768390", border: "1px solid gray",
            borderRadius: 10, padding: 10
        } },
        React.createElement(React.Fragment, null,
            " ",
            (profile && (type === "user" || type === "profile")) ? (React.createElement(GithubProfileCard, { html_url: profile.html_url, login: profile.login, avatar_url: profile.avatar_url, following: profile.following, followers: profile.followers, public_repos: profile.public_repos, public_gists: profile.public_gists, bio: profile.bio, location: profile.location, name: profile.name })) : (React.createElement(React.Fragment, null))),
        React.createElement(React.Fragment, null, repo ? (React.createElement(GithubRepoCard, { html_url: repo.html_url, name: repo.name, description: repo.description, language: repo.language, stargazers_count: (repo === null || repo === void 0 ? void 0 : repo.stargazers_count) || 0, forks_count: repo === null || repo === void 0 ? void 0 : repo.forks_count, watchers: repo === null || repo === void 0 ? void 0 : repo.watchers })) : React.createElement(React.Fragment, null))));
};
